"use client";

/**
 * Light/dark toggle — retired.
 *
 * The app is now dark-only (HighBid): the theme is forced dark at the provider
 * (`forcedTheme="dark"`), so there is no alternate mode to switch to. This
 * renders nothing rather than a dead control; the call sites (admin + docs
 * headers) keep their structure and can drop the import later. Kept as a
 * no-op — not deleted — so re-introducing a toggle is a one-file change.
 */
export function ModeToggle() {
  return null;
}
